<template>
  <div id="auth">
    <div v-if="loading" id="preloader">
      <div class="spinner"></div>
    </div>
    <div v-else>
      <transition appear name="slide-fade">
        <div>
          <!-- Page Content -->
          <div class="page-content">
            <!-- Banner -->
            <div class="banner-wrapper shape-1">
              <div class="container inner-wrapper">
                <h2 class="dz-title">Upps!</h2>
                <p class="mb-0">Parece que hubo un error...</p>
              </div>
            </div>
            <!-- Banner End -->
            <div class="container">
              <div class="account-area">
                <div
                  class="alert alert-danger light fade text-center show"
                  style="font-size: 1.2em"
                >
                  <svg
                    viewBox="0 0 24 24"
                    width="20"
                    height="20"
                    stroke="currentColor"
                    stroke-width="2"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="me-2"
                  >
                    <polygon
                      points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"
                    ></polygon>
                    <line x1="15" y1="9" x2="9" y2="15"></line>
                    <line x1="9" y1="9" x2="15" y2="15"></line>
                  </svg>
                  <strong
                    >No reconocemos el QR que has registrado. Por favor verifica
                    e inténtalo de nuevo.</strong
                  >
                </div>
              </div>
            </div>
          </div>
          <!-- Page Content End -->
          <!-- Footer -->
          <footer class="footer fixed">
            <div class="container">
              <router-link
                to="/leer_qr"
                class="btn btn-primary light btn-rounded text-primary d-block"
                >Reintentar</router-link
              >
              <router-link
                to="/"
                class="btn btn-outline-light btn-rounded mt-1 d-block"
                >Cancelar</router-link
              >
            </div>
          </footer>
          <!-- Footer End -->
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
export default {
  name: "Error_leer_qr",
  metaInfo: {
    title: "Escanear QR - Reddy App",
  },
  data() {
    return {
      loading: true,
      session: null,
      usuario: null,
    };
  },
  created: function () {
    var session = localStorage.getItem("sess_reddy_app");
    if (session == undefined) {
      this.$router.push("/auth");
    } else {
      session = JSON.parse(session);
      this.session = session;
      this.usuario = session.usuario;
    }
  },
  methods: {},
  mounted: function () {
    this.loading = false;
  },
};
</script>